<template>
	<div class="ipv6-list-container init">
		<div class="cps-page-top">
			<div class="jc-page-header">
				<el-page-header :title="$t('ipv6.text.ipv6')" />
				<div class="jc-box-action">
					<a :href="Config.IPV6_URL" target="_blank">{{ $t('ipv6.help.doc') }}</a>
				</div>
			</div>
			<div class="jc-page-content">
				<div class="jc-container-table">
					<div class="jc-container-table-actionBar flex-display">
						<!--刷新、地域、申请-->
						<el-form class="jc-table-actionBar-item" :inline="true">
							<el-form-item>
								<el-button icon="jc-icon-refresh-line" class="jc-button-icon"
									@click="updateList('refresh')">
								</el-button>
							</el-form-item>
							<el-form-item>
								<el-radio-group v-model="region" @change="regionChange">
									<el-radio-button v-for="(area, index) in region_map"
										:key="index"
										:label="area.region">
										{{ area.regionName }}
									</el-radio-button>
								</el-radio-group>
							</el-form-item>
						</el-form>
						<!--搜索、自定义-->
						<el-form class="jc-box-table-search" :inline="true" @submit.native.prevent>
							<el-form-item>
								<el-input 
									class="search-input"
									v-entire-placeholder
									@keyup.enter.native="updateList('refresh')"
									:placeholder="currentPlaceholder"
									v-model="currentSearchValue">
									<el-select 
										slot="prepend" id="my-select" v-model="currentSearch"
										@change="changeSearch"
										class="my-select-select"
										:placeholder="$t('ipv6.text.gatewayId')">
										<el-option class="my-select-input" v-for="item in searchSelect"
											:key="item.searchValue"
											:label="item.searchLabel" :value="item.searchValue">
										</el-option>
									</el-select>
									<el-button 
										slot="append" icon="jc-icon-search" class="search-icon"
										@click="updateList('refresh')">
									</el-button>
								</el-input>
							</el-form-item>
							<el-form-item>
								<el-button icon="el-icon-setting" class="jc-button-icon cps-custom-icon"
									@click="customVisible = true"
									:title="$t('listPage.text.customList')">
								</el-button>
							</el-form-item>
						</el-form>
						
					</div>
					<!--ipv6列表-->
					<el-table 
						:data="tableData" style="width:100%"
						class="jc-list-table jc-table-header-cell" v-loading="refreshLoading"
						ref="listTable"
						:empty-text="$t('speechCraft.listEmptyText')">
						<!--ID/网关名称-->
						<el-table-column :label="$t('ipv6.text.idOrGatewayName')" 
							key="ipv6GatewayId"
							v-if="customInfo !== null && customInfo['id'].selected">
							<template slot-scope="scope">
								<!--ID-->
								<el-tooltip class="item" effect="dark" :content="scope.row.ipv6GatewayId"
									placement="bottom">
									<span>{{scope.row.ipv6GatewayId | maybeEmpty}}</span>
								</el-tooltip>
								<br/>
								<!--网关名称-->
								<el-tooltip class="item" effect="dark" :content="scope.row.ipv6GatewayName"
									placement="bottom">
									<a href="javascript:void(0)"
										@click="jumpToDetail(scope.row.ipv6GatewayId, scope.row.region)">{{scope.row.ipv6GatewayName
										| maybeEmpty}}</a>
								</el-tooltip>
							</template>
						</el-table-column>
						<!--私有网络-->
						<el-table-column prop="vpcName" 
							:label="$t('ipv6.text.privateNetwork')"
							v-if="customInfo !== null && customInfo['vpcName'].selected">
							<template slot-scope="scope">
								<a href="javascript:void(0)" @click="jumpToVpcDetail(scope.row.vpcId, scope.row.region)">{{scope.row.vpcName | maybeEmpty}}</a>
							</template>
						</el-table-column>
						<!--创建时间-->
						<el-table-column prop="datetime"
							:label="$t('ipv6.text.createTime')"
							v-if="customInfo !== null && customInfo['datetime'].selected">
							<template slot-scope="scope">
								<span>{{scope.row.createTime | maybeEmpty}}</span>
							</template>
						</el-table-column>
						<!--操作-->
						<el-table-column key="operation"
							:label="$t('listPage.tableLabel.operation')"
							v-if="customInfo !== null && customInfo['operation'].selected">
							<template slot-scope="scope">
								<a href="javascript:void(0)" @click="manangeIpv6Address(scope.row)">
									{{$t('ipv6.text.manageIpv6Address')}}
								</a>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
			<custom :visible.sync="customVisible" v-if="customVisible" :optionArr="optionArr"
				:type="type"></custom>
		</div>
		<div ref="footer" class="cps-page-footer block jc-container-table-actionBar" v-if="total > 0">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="currentPage"
				:page-sizes="pageSizes" :page-size="pageSize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total">
			</el-pagination>
		</div>
	</div>
</template>

<script>
import {
	NetworkTypeConstant
} from '@/common/Constants';
import custom from '@/components/common/custom/Custom';
const initPage = 1;

export default {
	components: {
		custom,
	},
	name: 'Ipv6List',
	data() {
		// 模糊搜索条件设置
		const searchSelect = [
			{
				searchValue: 'gatewayId',
				searchLabel: this.$t('ipv6.text.gatewayId')
			},
			{
				searchValue: 'gatewayName',
				searchLabel: this.$t('ipv6.text.gatewayName')
			}
		];
		return {
			clientToken: Normal.getClientToken(),
			currentPage: initPage,
			initPage,
			form: {},
			region_map: [],
			region: null,
			tableData: [],
			refreshLoading: false,
			regionMap: {},
			gatewayIdSearch: '',
			nameSearch: '',
			currentSearch: 'gatewayId',
			// 当前搜索input框值
			currentSearchValue: '',
			// 搜索条件下拉选
			searchSelect,
			// 当前搜索条件对应placeholder
			currentPlaceholder: this.$t('ipv6.placeholder.search.gatewayId'),
			pageSize: 20,
			pageSizes: [20, 50, 100], // 可选每页展示多少条
			total: 0,
			// 自定义列表是否显示
			customVisible: false,
			// 自定义列表表头
			optionArr: [
				{
					// ID/网关名称
					label: this.$t('eip.text.publicIdOrAddress'),
					value: 'id'
				},
				{
					// 私有网络
					label: this.$t('ipv6.text.privateNetwork'),
					value: 'vpcName'
				},
				{
					// 创建时间
					label: this.$t('ipv6.text.createTime'),
					value: 'datetime'
				},
				{
					// 操作
					label: this.$t('listPage.tableLabel.operation'),
					value: 'operation'
				}
			],
			// 自定义列表类型
			type: 'ipv6GatewayList',
			// 当前行所有数据
			currentRow: null,
		};
	},
	computed: {
		customInfo() {
			return this.$store.state.customInfo[this.type];
		}
	},
	watch: {
		region(newValue) {
			if(newValue) {
				this.regionChange()
			}
		},
	},
	created() {
		if (this.$store.state.customInfo[this.type] === null) {
			this.getCustomInfo();
		}
		this.getRegion();
	},
	methods: {
		// 获取IPv6网关列表
		getIpv6ListData() {
			// 基础参数
			const param = {
				region: this.region,
				pageNumber: this.currentPage,
				pageSize: this.pageSize,
			};
			// 搜索部分添加参数
			if (this.currentSearchValue !== '') {
				switch (this.currentSearch) {
					case 'gatewayId': {
						param.ipv6GatewayIds = this.currentSearchValue;
						break;
					}
					case 'gatewayName': {
						param.ipv6GatewayName = this.currentSearchValue;
						break;
					}
				}
			}
			Ajax.get('/api/cps/listIpv6Gateways', param)
			.then((res) => {
				const list = res.data.ipv6Gateways;
				this.tableData = list;
				this.total = res.data.totalCount;
			})
			.catch(async (err) => {
                const { response } = err.data;
                try {
                    const json = await response.json();
                    // this.$message.error(json.errmsg);
                    this.tableData = [];
                    this.total = 0;
                } catch (ex) {
                    console.log(ex);
                }
            })
            .finally(() => {
                this.refreshLoading = false;
            });
		},
		getRegion() {
			const params = {
				networkType: NetworkTypeConstant.VPC
			};
			Ajax.get('api/cps/getRegions', params).then((res) => {
				const target = this;
				if (res.data) {
				  	res.data.regions.forEach((region, index) => {
						if (index === 0) {
							if (target.$route.query && target.$route.query.region) {
								target.region = target.$route.query.region;
							} else {
								target.region = region.region;
							}
						}
						const tempFormat = {};
						tempFormat.region = region.region;
						tempFormat.regionName = region.regionName;
						target.region_map.push(tempFormat);
				  	});
				}
			}) 
			.catch()
	        .finally(() => {
	        	this.loading = false
	        });
		},
		updateList(type) {
			if (type === 'refresh') {
				this.refreshLoading = true;
				this.currentPage = 1;
			}
			this.getIpv6ListData();
		},
		// 选择地区
		regionChange() {
			this.currentSearchValue = '';
			this.updateList('refresh');
		},
		// 跳转到详情页
		jumpToDetail(id, region) {
			this.$router.push({
				path: `/ipv6/detail`,
				query: {
					id: id,
					region: region,
					tabName: 'sourceInfo'
				}
			});
		},
		// 修改搜索条件
		changeSearch() {
			const searchPlaceholder = this.$t('ipv6.placeholder.search');
			const currentSearchVar = this.currentSearch;
			this.currentPlaceholder = searchPlaceholder[currentSearchVar];
			// 清空当前搜索条件
			this.currentSearchValue = '';
		},
		// 切换每一页多少条
		handleSizeChange(val) {
			this.pageSize = val;
			this.updateList('refresh');
		},
		// 切换当前页
		handleCurrentChange(val) {
			this.currentPage = val;
			this.getIpv6ListData();
		},
		getCustomInfo() {
			const param = {
				pageKey: this.type
			};
			Ajax.get('/api/usercenter/getCustomInfo', param)
	        .then((res) => {
	          	if (res.data.customInfo) {
	            	this.$store.commit(
			            'GET_CUSTOMINFO',
			            { value: res.data.customInfo, type: this.type }
	            	);
	          	}
	        });
		},
		manangeIpv6Address(row) {
			let region = this.region;
			let id = row.ipv6GatewayId;
			this.$router.push({
				path: `/ipv6/detail`,
				query: {
					id: id,
					region: region,
					tabName: 'ipv6Eip'
				}		
	        });
		},

		jumpToVpcDetail(id, region) {
			this.$router.push({
				path: `/vpc/detail`,
				query: {
					id: id,
					region: region,
					tabName: 'source'
				}		
	        });
		}
	}
};
</script>


<style lang="scss">
	@import '../../../assets/scss/listComon.scss';
	@import "../../../assets/scss/paginationCommon";
	@import 'style';
</style>



// WEBPACK FOOTER //
// src/views/ipv6/list/List.vue